import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";

const meses = {
  1: "Enero",
  2: "Febrero",
  3: "Marzo",
  4: "Abril",
  5: "Mayo",
  6: "Junio",
  7: "Julio",
  8: "Agosto",
  9: "Septiembre",
  10: "Octubre",
  11: "Noviembre",
  12: "Diciembre"
};

const mesesOpts = [];
for (const key in meses) {
  mesesOpts.push({
    label: meses[key],
    value: key
  });
}

const currentYear = new Date().getFullYear();
const aniosOpts = [{ label: currentYear - 1, value: currentYear - 1 }];

export type Inputs = "mes" | "anio" | "idAsesor";

export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts
      }
    },
    {
      name: "idAsesor",
      label: "* Asesor",
      bts: { mCol: 4 },
      component: IUserSelectorBuilder
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 2 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      requiredMes: {
        validator: value => !value,
        message: () => "Campo obligatorio"
      }
    },
    idAsesor: {
      requiredAsesor: {
        validator: value => !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [["mes", "anio", "idAsesor", "buscar"]]
};
